import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import eggAnimation from "../../../assets/video/myth-fact-egg.mp4";

export function EggAnimation({ faded = false }) {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    video.currentTime = 0;
    const play = () => video.play().catch(() => {});
    if (video.readyState >= 2) play();
    else video.addEventListener("loadeddata", play, { once: true });
    return () => video.removeEventListener("loadeddata", play);
  }, []);

  return (
    <Box
      component="video"
      ref={videoRef}
      src={eggAnimation}
      autoPlay
      muted
      loop
      playsInline
      aria-label="Easter egg opening"
      sx={{
        width: "100%",
        height: "auto",
        display: "block",
        mb: 1,
        bgcolor: "transparent",
        pointerEvents: "none",
        filter: faded ? "saturate(0.22)" : "none",
      }}
    />
  );
}
